// ordenServicioTrasladoSchema.tsx

import * as yup from 'yup';

export const ordenServicioTrasladoSchema = yup.object({
    coordenadas: yup.string().required('campo obligatorio'),
    direccion: yup.string()
    .min(20, 'La dirección debe tener al menos 20 caracteres')
    .matches(
      /^[^_-]*$/,
      'No se permiten guiones (-) ni guiones bajos (_)'
    )
    .required('Campo Obligatorio'),
    tipo_orden_servicio: yup.string().required('campo obligatorio'),
    provincia: yup.string().required('campo obligatorio'),
    ciudad: yup.string().required('campo obligatorio'),
    sector: yup.string().required('campo obligatorio'),
    zona: yup.string().required('campo obligatorio'),
    parroquia: yup.string().required('campo obligatorio'),

});
